import { useCallback, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllWellnessCheck } from "../../api/wellnessCheck";
import { wellnessChecksKeys } from "./queryKey";
import { useAppState } from "../../stores/appContext";

export const useAllWellnessChecks = () => {
    const queryClient = useQueryClient();
    const appState = useAppState();

    const { data: wellnessChecks, isLoading } = useQuery(
        wellnessChecksKeys.all,
        () => getAllWellnessCheck(),
        { enabled: appState.isLoggedIn }
    );

    const clearCache = useCallback(async () => {
        await queryClient.invalidateQueries(wellnessChecksKeys.all);
    }, [queryClient]);

    const hasNewWellnessCheck = useMemo(
        () =>
            wellnessChecks?.some((wellnessCheck) => wellnessCheck.isUnread) ??
            false,
        [wellnessChecks]
    );

    return {
        wellnessChecks: wellnessChecks ?? [],
        isLoading,
        clearCache,
        hasNewWellnessCheck,
    };
};
